import { defineMessages } from 'react-intl';

const translations = {
  open: {
    id: 'shipmentStatusses.open',
    defaultMessage: 'Open',
    description: 'label of the status open',
  },
  cancelled: {
    id: 'shipmentStatusses.cancelled',
    defaultMessage: 'Cancelled',
    description: 'label of the status cancelled',
  },
  listed: {
    id: 'shipmentStatusses.listed',
    defaultMessage: 'On handling list',
    description: 'label of the status listed',
  },
  boxed: {
    id: 'shipmentStatusses.boxed',
    defaultMessage: 'Boxed',
    description: 'label of the status boxed',
  },
  inTransit: {
    id: 'shipmentStatusses.inTransit',
    defaultMessage: 'In transit',
    description: 'label of the status in transit',
  },
  counted: {
    id: 'shipmentStatusses.counted',
    defaultMessage: 'Counted',
    description: 'label of the status counted',
  },
  picked: {
    id: 'shipmentStatusses.picked',
    defaultMessage: 'Picked',
    description: 'label of the status picked',
  },
  placed: {
    id: 'shipmentStatusses.placed',
    defaultMessage: 'Placed',
    description: 'label of the status placed',
  },
  finished: {
    id: 'shipmentStatusses.finished',
    defaultMessage: 'Finished',
    description: 'label of the status finished',
  },
};

export default defineMessages(translations);
